//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VocMenuItem",
  props: {
    route: {
      type: Object,
      default: () => ({})
    },
    currentMenu: {
      type: Object,
      default: () => ({})
    },
    menuIntroductions: {
      type: Object,
      default: () => ({})
    },
    getRouteName: {
      type: Function,
      default: () => ""
    },
    deep: {
      type: Number,
      default: 1
    },
    onMenuSelect: {
      type: Function,
      default: () => {}
    },
    targetElement: {
      type: String,
      default: ""
    },
    activePath: {
      default: () => []
    }
  },
  methods: {
    getIndex(route) {
      let systemName = route.path.includes("hotelcem") ? "hotelcem" : "workflow"
      const pathArr = route.path.split(systemName)
      if (pathArr.length > 1) {
        return pathArr[1]
      }

      return route.path
    },
    getImageUrl(route) {
      const source = this.menuIntroductions[route.code].source || ""
      const images = source.split(";")
      const active = this.activePath.includes(route.code)
      if (images.length > 1 && active) {
        return images[1]
      }
      return images[0]
    }
  }
}
